<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="process-time-line-title" :field="fields?.title" tag="h2" />
      <div class="process-time-line-content" v-if="fields?.stepList?.length > 0">
        <div class="process-time-line-step">
          <div
            class="process-time-line-step-item"
            v-for="(item, index) in fields?.stepList"
            :key="index"
          >
            <JssRichText class="process-time-line-step-item-time" :field="item?.fields?.time" />
            <div class="process-time-line-step-item-empty" v-if="!item?.fields?.time?.value"></div>
            <div
              class="process-time-line-step-item-icon"
              :style="{ backgroundColor: item?.fields?.iconBgColor?.value }"
            ></div>
            <JssRichText class="process-time-line-step-item-desc" :field="item?.fields?.desc" />
          </div>
          <div class="process-time-line-step-line"></div>
        </div>
      </div>
      <div class="process-time-line-tag">
        <JssRichText class="process-time-line-tag-desc" :field="fields?.tag" />
      </div>
      <div class="process-time-line-card" v-if="fields?.cardList?.length > 0">
        <div class="process-time-line-card-item" v-for="item in fields?.cardList" :key="item?.id">
          <div class="process-time-line-card-item-header">
            <JssRichText
              class="process-time-line-card-item-header-title"
              :field="item?.fields?.title"
            />
            <JssRichText
              class="process-time-line-card-item-header-desc"
              :field="item?.fields?.desc"
            />
          </div>
          <JssRichText class="process-time-line-card-item-tag" :field="item?.fields?.tag" />
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'ProcessTimeLine',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'process-time-line'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.process-time-line {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-content {
    width: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-step {
    display: flex;
    background-color: #f6faf9;
    padding: 19px 16px;
    margin-top: 40px;
    gap: 16px;
    border-radius: 16px;
    position: relative;
    width: 1335px;

    &-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      z-index: 2;

      &-time {
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        color: $blue-night;
        text-align: center;
        position: relative;
        right: -55px;
      }

      &-empty {
        height: 20px;
      }

      &-icon {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        margin-top: 22px;
      }

      &-desc {
        font-size: 14px;
        font-weight: 700;
        line-height: 1.2;
        color: $grey-black;
        margin-top: 12px;
        text-align: center;
      }
    }

    &-line {
      width: calc(100% - 60px);
      height: 2px;
      background: linear-gradient(90deg, #d4d4d4, #a8a8a8);
      position: absolute;
      top: 75px;
      left: 30px;
      z-index: 1;
    }
  }

  &-tag {
    background-color: #f6faf9;
    padding: 19px 16px;
    margin-top: 24px;
    border-radius: 16px;
    text-align: center;
    font-size: 14px;
    color: $grey-black;
    font-weight: 700;
    width: 100%;
  }

  &-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;
    width: 100%;

    &-item {
      flex: 1;
      border: 1px solid #ececec;
      border-radius: 16px;
      padding: 20px;

      &-header {
        background-color: #f6faf9;
        border-radius: 16px;
        padding: 16px;

        &-title {
          font-size: 18px;
          font-weight: 700;
          line-height: 20px;
          color: $grey-black;
        }

        &-desc {
          font-size: 14px;
          line-height: 1.2;
          color: $grey-black;
          margin-top: 12px;
        }
      }

      &-tag {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
        color: $grey-black;
        margin-top: 12px;
      }
    }
  }

  @include tablet-landscape {
    width: 100%;
    padding: 60px 0;

    &-step {
      width: 100%;
    }

    &-card {
      flex-direction: row;
    }
  }
}
</style>
